<template>
    <div class="impressum-view">
        <!-- Header -->
        <HeaderComponent />

        <!-- Navigation Bar -->
        <nav class="legal-navigation">
            <div class="container">
                <div class="d-flex justify-content-start align-items-center">
                    <button @click="goBack" class="btn-back">
                        &lt; zurück
                    </button>
                </div>
            </div>
        </nav>

        <!-- Content -->
        <main class="legal-content">
            <div class="container">
                <div class="legal-page">
                    <h1 class="legal-title">Impressum</h1>
                    
                    <section class="legal-section">
                        <h2>Diensteanbieter</h2>
                        <div class="contact-info">
                            <p><strong>Sylvia Braun</strong></p>
                            <p>Blochbachstr. 4<br>
                            63486 Bruchköbel</p>
                        </div>
                    </section>

                    <section class="legal-section">
                        <h2>Kontaktmöglichkeiten</h2>
                        <div class="contact-info">
                            <p>E-Mail-Adresse: <a href="mailto:mail@sylvia-braun.de">mail@sylvia-braun.de</a></p>
                            <p>Telefon: <a href="tel:0175-4035313">0175-4035313</a></p>
                        </div>
                    </section>

                    <section class="legal-section">
                        <h2>Social Media und andere Onlinepräsenzen</h2>
                        <p>Dieses Impressum gilt auch für die folgenden Social-Media-Präsenzen und Onlineprofile:</p>
                        <p><a href="https://www.facebook.com/besser4brk" target="_blank" rel="noopener noreferrer">https://www.facebook.com/besser4brk</a></p>
                    </section>

                    <section class="legal-section">
                        <h2>Haftungs- und Urheberrechtshinweise</h2>
                        <h3>Urheberrechte und Markenrechte</h3>
                        <p>Alle auf dieser Website dargestellten Inhalte, wie Texte, Fotografien, Grafiken, Marken und Warenzeichen sind durch die jeweiligen Schutzrechte (Urheberrechte, Markenrechte) geschützt. Die Verwendung, Vervielfältigung usw. unterliegen unseren Rechten oder den Rechten der jeweiligen Urheber bzw. Rechteverwalter.</p>
                    </section>

                    <section class="legal-section">
                        <h2>Bildnachweise</h2>
                        <p><strong>Bildquellen und Urheberrechtshinweise:</strong></p>
                        <ul>
                            <li>Eigene</li>
                            <li>pixelstein.de</li>
                        </ul>
                    </section>
                </div>
            </div>
        </main>

        <!-- Footer -->
        <FooterComponent />
    </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
    name: 'ImpressumView',
    components: {
        HeaderComponent,
        FooterComponent
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>